import { createLucideIcon } from 'lucide-react';

export const CircleProgressSolid = createLucideIcon('CircleProgressSolid', [
  [
    'path',
    {
      d: 'M13 1A11 11 0 1 1 1.2 12H13z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
